"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var p4_css_1 = require("p4-css");
var useSlider_1 = tslib_1.__importDefault(require("react-use/lib/useSlider"));
var RailWrap_1 = require("../RailWrap");
var Rail_1 = require("../Rail");
var useRef = React.useRef;
var volumeSliderClass = p4_css_1.rule({
    d: 'flex',
    flex: '0 0 100px',
    w: '100px',
    h: '100%',
    alignItems: 'center',
    cur: 'pointer',
    marr: '16px',
    cursor: 'ew-resize',
});
exports.Volume = function (_a) {
    var value = _a.value, bg = _a.bg, rail = _a.rail, railHover = _a.railHover, onChange = _a.onChange;
    var volumeRef = useRef(null);
    var _b = React.useState(false), hover = _b[0], setHover = _b[1];
    useSlider_1.default(volumeRef, {
        onScrub: onChange,
    });
    return (React.createElement("span", { ref: volumeRef, className: volumeSliderClass, onMouseEnter: function () { return setHover(true); }, onMouseLeave: function () { return setHover(false); } },
        React.createElement(RailWrap_1.RailWrap, null,
            React.createElement(Rail_1.Rail, { value: 1, color: bg }),
            !!value && React.createElement(Rail_1.Rail, { value: value, color: hover ? railHover : rail }))));
};
